import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import InventoryDashboard from './components/InventoryDashboard';
import WarehouseDashboard2 from './Warehouse/components/WarehouseDashboard2';
import WarehouseDistribution2 from './Warehouse/components/WarehouseDistribution2';
import CommissaryDashboard from './Commissary/components/CommissaryDashboard';
import CommissaryDistribution from './Commissary/components/CommissaryDistribution';
import StockLists from '../Stocks/components/StockLists';
import StocksDistribution from '../Stocks/components/StocksDistribution';

class Inventory extends PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        inventorytype: PropTypes.string,
      }).isRequired,
    }).isRequired,
  }

  constructor() {
    super();
    this.userData = JSON.parse(localStorage.getItem('userData'));
  }

  render() {
    const { match } = this.props;
    const { params } = match;
    const { inventorytype, page, itemID } = params;
    const page1 = ['warehouse', 'logistic', 'retailstore'];
    const page2 = ['dashboard', 'distribution', 'list'];

    if (this.userData == null || this.userData.type === '4') {
      return (<Redirect to="/login" />);
    }

    if ((inventorytype === undefined || page1.indexOf(inventorytype) === -1) || (page === undefined || page2.indexOf(page) === -1)) {
      return (<Redirect to={`/inventory/${page1.indexOf(inventorytype) > -1 ? inventorytype : 'warehouse'}/list`} />);
    }

    if (['dashboard', 'distribution'].indexOf(page) !== -1 && itemID == null && ['1', '5', '6'].indexOf(this.userData.type) > -1) {
      return (<Redirect to="/login" />);
    }

    if (inventorytype === 'retailstore' && page2.indexOf(page) > -1 && (this.userData.type !== '1' && this.userData.type !== '5')) {
      return (<Redirect to="/login" />);
    }

    return (
      <Container>
        <Row>
            {
              page === 'distribution' && inventorytype === 'warehouse' ? <WarehouseDistribution2 itemID={itemID} />
              : page !== 'list' && inventorytype === 'warehouse' ? <WarehouseDashboard2 itemID={itemID} />
              : page === 'distribution' && inventorytype === 'logistic' ? <CommissaryDistribution itemID={itemID} />
              : page !== 'list' && inventorytype === 'logistic' ? <CommissaryDashboard itemID={itemID} />
              : page === 'distribution' && inventorytype === 'retailstore' ? <StocksDistribution itemID={itemID} />
              : page !== 'list' && inventorytype === 'retailstore' ? <StockLists itemID={itemID} />
              : <InventoryDashboard type={inventorytype} />
            }
        </Row>
      </Container>
    );
  }
}

export default withTranslation('common')(Inventory);
